module.exports = __webpack_public_path__ + "static/media/d3.b1361723.jpg";